module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ht"
  }, [_c('a', {
    attrs: {
      "id": "pI"
    }
  }), _vm._v("GALLIPOLI")]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("R"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("OBIN")]), _vm._v(" P"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("RIOR")]), _vm._v(" is visiting professorial fellow, University of Adelaide, and visiting fellow, University of New South Wales, Australian Defence Force Academy. He is coauthor with Trevor Wilson of "), _c('i', [_vm._v("Passchendale: The Untold Story")]), _vm._v(" (1996) and "), _c('i', [_vm._v("The Somme")]), _vm._v(" (2005), both published by Yale.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94f0c83a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/half_title.vue
// module id = 57
// module chunks = 0